import { selectAtom } from "jotai/utils";
import { questionnaireReducerAtom } from "./questionnaireReducerAtom";

/**
 * Atom that selects the isEditing flag from the questionnaire state.
 *
 * This atom only triggers re-renders when the isEditing flag changes.
 * Editing mode is used when modifying previously submitted answers
 * (e.g., in assumptions flow).
 */
export const questionnaireIsEditingAtom = selectAtom(
  questionnaireReducerAtom,
  state => state.isEditing,
);
